import React, { useState, useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "./Home.css";

const slides = [
  {
    src: "/first.jpg",
    overlay: "/first111.png",
    title: "Women Empowerment",
    tagline:
      "Increase access to livelihood support,\nmake them empowered and independent",
  },
  {
    src: "/first2.jpg",
    overlay: "/first33.png",
    title: "Elder Care Services",
    tagline: "Love, respect, and support every day",
  },
  {
    src: "/first3.jpg",
    overlay: "/first22.png",
    title: "Education",
    tagline: "Learning that leads to growth and independence",
  },
  {
    src: "/first4.png",
    overlay: "/first44.png",
    title: "Caring for Your Health",
    tagline:
      "Delivering quality care with empathy, safety, and commitment",
  },
  {
    src: "/first10.png",
    overlay: "/first55.png",
    title: "RK Ramesh",
    role: "Founder & Managing Trustee",
    tagline: "Thank you for believing in our vision and mission",
  },
];

export default function Home() {
  const [currentIndex, setCurrentIndex] = useState(0);

  /* ✅ AOS INIT (RUN ONCE) */
  useEffect(() => {
    AOS.init({
      duration: 1000,
      easing: "ease-out-cubic",
      once: true,
    });
  }, []);

  /* ✅ AUTO SLIDE (SAFE TIMING) */
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prev) =>
        prev === slides.length - 1 ? 0 : prev + 1
      );
    }, 4500);

    return () => clearInterval(interval);
  }, []);

  /* ✅ LIGHTWEIGHT AOS REFRESH ON SLIDE CHANGE */
  useEffect(() => {
    AOS.refresh();
  }, [currentIndex]);

  const prevSlide = () => {
    setCurrentIndex((prev) =>
      prev === 0 ? slides.length - 1 : prev - 1
    );
  };

  const nextSlide = () => {
    setCurrentIndex((prev) =>
      prev === slides.length - 1 ? 0 : prev + 1
    );
  };

  const currentSlide = slides[currentIndex];

  return (
    <div className="carousel-container">
      <button className="carousel-btn prev" onClick={prevSlide}>
        &#10094;
      </button>

      <div className="carousel-wrapper">
        {/* 🔥 KEY = currentIndex (IMPORTANT FIX) */}
        <div className="carousel-item" key={currentIndex}>
          {/* BACKGROUND IMAGE */}
          <img
            src={currentSlide.src}
            alt="background"
            className="bg-image"
          />

          {/* OVERLAY IMAGE */}
          {currentSlide.overlay && (
            <div
              className={`overlay-image overlay-${currentIndex}`}
              data-aos="zoom-in"
            >
              <img src={currentSlide.overlay} alt="overlay" />
            </div>
          )}

          {/* TITLE */}
          <h2
            className={`carousel-title title-${currentIndex}`}
            data-aos="fade-left"
          >
            {currentSlide.title}
          </h2>

          {/* ROLE (Founder slide only) */}
          {currentSlide.role && (
            <p
              className="carousel-role"
              data-aos="fade-left"
              data-aos-delay="200"
            >
              {currentSlide.role}
            </p>
          )}

          {/* TAGLINE */}
          {currentSlide.tagline && (
            <p
              className={`carousel-tagline tagline-${currentIndex}`}
              data-aos="fade-up"
              data-aos-delay="400"
            >
              <span className="tagline-text">
                {currentSlide.tagline}
              </span>
            </p>
          )}
        </div>
      </div>

      <button className="carousel-btn next" onClick={nextSlide}>
        &#10095;
      </button>
    </div>
  );
}
